var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWordPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 64,
    height: 64,
    rx: 12,
    transform: "rotate(180 64 64)",
    fill: "#C6E1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 33.6666C42 38.3807 42 40.7377 40.5355 42.2022C39.0711 43.6666 36.714 43.6666 32 43.6666H27C22.286 43.6666 19.9289 43.6666 18.4645 42.2022C17 40.7377 17 38.3807 17 33.6666V25.3333C17 20.6192 17 18.2622 18.4645 16.7978C19.9289 15.3333 22.286 15.3333 27 15.3333H32C36.714 15.3333 39.0711 15.3333 40.5355 16.7978C42 18.2622 42 20.6192 42 25.3333V33.6666Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24H23",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29H23",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 34H23",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20.3333C44.7614 20.3333 47 22.5719 47 25.3333V35.3333C47 41.6187 47 44.7614 45.0474 46.714C43.0948 48.6666 39.9521 48.6666 33.6667 48.6666H27C24.2386 48.6666 22 46.428 22 43.6666",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWordPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/word-pdf.87aa218e7eac937c467015ef3b658f91.svg";